import type { ResourceProps } from 'react-admin';
import { CanAccess } from 'react-admin';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.auditLogs} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: AdminPanelSettingsIcon as ComponentType<any>,
} as ResourceProps;
